import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from 'react';
import { getCartDataApi, isApiSuccess, getApiData } from '../components/actioncreator';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartData, setCartData] = useState({ items: [] });

  const cartDataApi = useCallback(() => {
    const token = localStorage.getItem('btoken');
    if (!token) {
      setCartData({ items: [] });
      return;
    }

    getCartDataApi(token, (response) => {
      setCartData(isApiSuccess(response) ? getApiData(response) : { items: [] });
    });
  }, []);

  useEffect(() => {
    cartDataApi();
  }, [cartDataApi]);

  useEffect(() => {
    const handleAuthChange = () => {
      cartDataApi();
    };

    window.addEventListener('auth-session-changed', handleAuthChange);
    return () => window.removeEventListener('auth-session-changed', handleAuthChange);
  }, [cartDataApi]);

  const value = useMemo(() => ({ cartData, cartDataApi }), [cartData, cartDataApi]);

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
